export default function useInvitations() {
  return {
    invitations,
    user: undefined,
  };
}

const invitations = [
  {
    name: "Carmen W",
    square: 26,
    id: "1XByvXpotIR9kOr8kGi0",
    createdOn: { seconds: 1606838956, nanoseconds: 889000000 },
  },
  {
    square: 44,
    createdOn: { seconds: 1606839111, nanoseconds: 415000000 },
    id: "2Kwnh2wXzHRAAqJ9xRCX",
    name: "Melli H",
  },
  {
    square: 53,
    name: "Daniel H",
    id: "2YrwNFPMLEyyFVvINa3k",
    createdOn: { seconds: 1606836683, nanoseconds: 998000000 },
  },
  {
    name: "David H",
    createdOn: { seconds: 1606836806, nanoseconds: 10000000 },
    id: "3QddAT0LSv14J47FhrsO",
  },
  {
    name: "Frank",
    square: 29,
    createdOn: { seconds: 1606795161, nanoseconds: 763000000 },
    id: "3S9FKWoiStvSA0Nc0PUN",
  },
  {
    id: "3mQQnpBT1tLnoiHl6ubr",
    createdOn: { seconds: 1606843097, nanoseconds: 281000000 },
    name: "Laura T",
    square: 36,
  },
  {
    square: 68,
    createdOn: { seconds: 1606838356, nanoseconds: 282000000 },
    id: "5NjnZxJ71fV2sAVvwrXH",
    name: "Shelby & Jackman",
  },
  {
    id: "6RqlgeAERS6bdQ9YqLrj",
    createdOn: { seconds: 1606835805, nanoseconds: 815000000 },
    name: "Mark & Lauren",
    square: 38,
  },
  {
    square: 11,
    id: "7aUPjZwp0iVUERI6Si1q",
    createdOn: { seconds: 1606844049, nanoseconds: 801000000 },
    name: "Kate W",
  },
  {
    createdOn: { seconds: 1606836270, nanoseconds: 444000000 },
    name: "Brian & Kelsey",
    id: "8i72oFNuViDhrP7k7l8s",
    square: 16,
  },
  {
    name: "Brooke K",
    square: 10,
    id: "CRGByyDG0s39kkLUkxe3",
    createdOn: { seconds: 1606836918, nanoseconds: 797000000 },
  },
  {
    id: "EC7ahyvoOdDBR4Nw4Q0O",
    name: "Stephen & Jaimie",
    createdOn: { seconds: 1606838710, nanoseconds: 251000000 },
    square: 46,
  },
  {
    name: "Tony & Lindsay",
    id: "FP4Gp5XNM6GdgSPFWJwG",
    createdOn: { seconds: 1606837029, nanoseconds: 40000000 },
    square: 28,
  },
  {
    id: "FmAuJE7ScrZV7y8kkYLL",
    createdOn: { seconds: 1606838381, nanoseconds: 423000000 },
    name: "Stephen & Lauren",
    square: 71,
  },
  {
    name: "Richelle & Melissa",
    createdOn: { seconds: 1606837343, nanoseconds: 45000000 },
    square: 48,
    id: "GpDECHBYjhcVD7LZuMa4",
  },
  {
    square: 37,
    id: "GuDpCjccMk9lIIme62vR",
    name: "Jimmy & Michelle",
    createdOn: { seconds: 1606837086, nanoseconds: 766000000 },
  },
  {
    name: "Katie & John",
    createdOn: { seconds: 1608562353, nanoseconds: 780000000 },
    id: "H4B2VRit6OQThALwFXUU",
    square: 17,
  },
  {
    id: "HUSFo1ui1f8ORbf0Kgdt",
    createdOn: { seconds: 1608147562, nanoseconds: 980000000 },
    name: "Eric H",
  },
  {
    createdOn: { seconds: 1606844064, nanoseconds: 697000000 },
    id: "HjGZYlW0kVUVBLZ69XQ6",
    square: 1,
    name: "Kyle J",
  },
  {
    square: 41,
    name: "Spencer & Courtney",
    id: "HvBJNJxufagYMIiXxsYj",
    createdOn: { seconds: 1606838648, nanoseconds: 137000000 },
  },
  {
    name: "Daniel M",
    id: "IKxQ0nn3rJygdbR1yyzi",
    square: 23,
    createdOn: { seconds: 1606844702, nanoseconds: 482000000 },
  },
  {
    name: "Michaela H",
    square: 27,
    id: "KeXOq36bEKPDIMQjIjIQ",
    createdOn: { seconds: 1608563446, nanoseconds: 449000000 },
  },
  {
    square: 60,
    id: "LvFe3HxwTCSHLR9GWVmp",
    name: "Andrew & Megan",
    createdOn: { seconds: 1606838123, nanoseconds: 406000000 },
  },
  {
    square: 64,
    id: "R0QFIFNsL3huv72OEVRM",
    createdOn: { seconds: 1606836161, nanoseconds: 648000000 },
    name: "Travis & Sarah",
  },
  {
    square: 15,
    createdOn: { seconds: 1608562634, nanoseconds: 181000000 },
    id: "RSXy3yUCAYAtofIAJqYz",
    name: "Adam S",
  },
  {
    createdOn: { seconds: 1606838472, nanoseconds: 624000000 },
    id: "SEW40lva2nQ2pZSf5VkX",
    name: "Rich & Aimee",
    square: 34,
  },
  {
    name: "Glo K",
    id: "SLF1ar0kcGcZhkiQNERF",
    createdOn: { seconds: 1606833910, nanoseconds: 629000000 },
    square: 0,
  },
  {
    name: "Rebecca N",
    id: "SqEQL15cEh345HVVgqEw",
    square: 63,
    createdOn: { seconds: 1606835448, nanoseconds: 743000000 },
  },
  {
    id: "TSNNGaRZlpLSc9MjSx50",
    square: 6,
    createdOn: { seconds: 1606837952, nanoseconds: 693000000 },
    name: "Katie & Bob",
  },
  {
    createdOn: { seconds: 1606844695, nanoseconds: 412000000 },
    name: "Jonathan G",
    id: "VrO8Oxxq9cJCx2umAmeh",
  },
  {
    id: "WReW4JvHOt1waNLMz3mP",
    name: "Rik H",
    createdOn: { seconds: 1606836116, nanoseconds: 843000000 },
    square: 70,
  },
  {
    id: "YFa7s2057cTBeFu5i0yy",
    createdOn: { seconds: 1606836194, nanoseconds: 18000000 },
    square: 57,
    name: "Nate & Lauren",
  },
  {
    createdOn: { seconds: 1606844698, nanoseconds: 608000000 },
    id: "ZBz33Zg7snYnMNvxCp1Y",
    name: "Nora D",
    square: 58,
  },
  {
    createdOn: { seconds: 1606838844, nanoseconds: 632000000 },
    square: 4,
    id: "ZS7DO6lsSCQIqeoJ2Ug3",
    name: "Amy S",
  },
  {
    id: "ZYu7wXXZDbiBgQM70FhM",
    square: 39,
    createdOn: { seconds: 1606838311, nanoseconds: 149000000 },
    name: "Matt & Nichole",
  },
  {
    createdOn: { seconds: 1606835790, nanoseconds: 960000000 },
    square: 9,
    name: "Staci & Jason",
    id: "ZfMQzZrSy55Wv0bWdBFd",
  },
  {
    createdOn: { seconds: 1606838571, nanoseconds: 372000000 },
    id: "ZmlOcIn1dXFHGZs5ToG9",
    name: "Erin S",
    square: 31,
  },
  {
    createdOn: { seconds: 1606835945, nanoseconds: 749000000 },
    square: 43,
    name: "Corey & Charleen",
    id: "afQzTyb9QRrMjg0efHw8",
  },
  {
    createdOn: { seconds: 1606836059, nanoseconds: 698000000 },
    square: 61,
    name: "Ryan & Rachel",
    id: "c2oHcKyU1mhaREg96NEL",
  },
  {
    id: "dOGxLL423MSP7ZyJtHUx",
    createdOn: { seconds: 1606835608, nanoseconds: 995000000 },
    name: "Zach G",
    square: 69,
  },
  {
    name: "Scooter @ Camp Glo",
    square: 8,
    createdOn: { seconds: 1608005612, nanoseconds: 159000000 },
    id: "dohFBC7ETCvtGbMfmAyU",
  },
  {
    square: 30,
    createdOn: { seconds: 1606836020, nanoseconds: 868000000 },
    id: "e8sMj69rIouY3rYcNnuf",
    name: "Mike & Megan",
  },
  {
    square: 25,
    createdOn: { seconds: 1606836645, nanoseconds: 175000000 },
    id: "fhhwN7xoHKO4tJkJgSG6",
    name: "Jamie T",
  },
  {
    createdOn: { seconds: 1608563089, nanoseconds: 798000000 },
    name: "Peter R",
    id: "fpzUxOPP4BjDGEQmXaeK",
    square: 7,
  },
  {
    name: "Andrew W",
    createdOn: { seconds: 1606835673, nanoseconds: 781000000 },
    square: 13,
    id: "fsi6XgYPKQh26o6EUOgR",
  },
  {
    name: "Xavier O",
    square: 67,
    id: "gKWYtnTuEKc9GSqhxkSC",
    createdOn: { seconds: 1606836699, nanoseconds: 881000000 },
  },
  {
    name: "Brian K",
    square: 66,
    id: "gesI8TNYBcsiq4LtG1LS",
    createdOn: { seconds: 1606836329, nanoseconds: 563000000 },
  },
  {
    name: "Matt P",
    createdOn: { seconds: 1606837850, nanoseconds: 35000000 },
    id: "hGZUBgyeNa22tYbR1tz4",
    square: 3,
  },
  {
    id: "hbSCZd5q4cA3VI7jDcEv",
    createdOn: { seconds: 1607442920, nanoseconds: 991000000 },
    square: 55,
    name: "Graham S",
  },
  {
    createdOn: { seconds: 1606838782, nanoseconds: 280000000 },
    name: "Mike & Kate",
    id: "iEHb0Ns6Im2YrTqqPiSr",
  },
  {
    createdOn: { seconds: 1606835658, nanoseconds: 296000000 },
    square: 14,
    id: "iKK6G1xmAxg6WHsfin8N",
    name: "Adam C",
  },
  {
    createdOn: { seconds: 1606838191, nanoseconds: 41000000 },
    name: "AJ & Michelle",
    square: 45,
    id: "jRoBXpoAJhjwlxU03EC0",
  },
  {
    createdOn: { seconds: 1606837785, nanoseconds: 549000000 },
    id: "jcksK7eZoQcwfunRM0v1",
    name: "Austin & Jess",
    square: 65,
  },
  {
    createdOn: { seconds: 1606835755, nanoseconds: 920000000 },
    square: 56,
    name: "Mom & Dad",
    id: "kBBCFSBIeqy0ETEWuZ9C",
  },
  {
    square: 21,
    id: "kMEQQWDXay74SMc35HDu",
    name: "Jordan W",
    createdOn: { seconds: 1606836005, nanoseconds: 382000000 },
  },
  {
    createdOn: { seconds: 1606836941, nanoseconds: 78000000 },
    id: "mw2QQg2gKnK7zoOZRqAE",
    square: 51,
    name: "Hannah B",
  },
  {
    createdOn: { seconds: 1606835706, nanoseconds: 796000000 },
    id: "nJ8JixMPJFnJ6RxhOzjb",
    name: "Zach P",
    square: 2,
  },
  {
    id: "ncUbvNlcw2CCpw0DeivF",
    createdOn: { seconds: 1606836343, nanoseconds: 222000000 },
    name: "Brian D",
    square: 32,
  },
  {
    id: "neP2Gqz0AyE3n3TnXJnG",
    name: "Jason W",
    createdOn: { seconds: 1606837829, nanoseconds: 387000000 },
    square: 40,
  },
  {
    name: "Kyle S",
    createdOn: { seconds: 1606835588, nanoseconds: 816000000 },
    id: "pWuIxcplw6Gj1qODZMTT",
    square: 12,
  },
  {
    square: 50,
    name: "Charlie R",
    id: "qQTX9WFnUFp4ZTNoXd4t",
    createdOn: { seconds: 1606835631, nanoseconds: 759000000 },
  },
  {
    id: "rMskxdUTPP24cuoxvLsA",
    name: "Amy H",
    square: 5,
    createdOn: { seconds: 1606836380, nanoseconds: 563000000 },
  },
  {
    id: "rTpPxNC3vzy8I0ZxmOWJ",
    name: "Anthony & Hannah",
    createdOn: { seconds: 1606838286, nanoseconds: 596000000 },
    square: 19,
  },
  {
    name: "Joe & Dana",
    id: "rmY55nI3GmMpkuMmLQnD",
    createdOn: { seconds: 1606836207, nanoseconds: 523000000 },
    square: 20,
  },
  {
    createdOn: { seconds: 1608562807, nanoseconds: 499000000 },
    square: 49,
    id: "rwYtUtbPwfdZ6yQbl72j",
    name: "Parker F",
  },
  {
    name: "Andrew & Helen",
    id: "tnI3DXVe2XqA7VTQhmsY",
    createdOn: { seconds: 1606837465, nanoseconds: 399000000 },
    square: 54,
  },
  {
    name: "Andrew B",
    square: 59,
    createdOn: { seconds: 1606837110, nanoseconds: 67000000 },
    id: "tpatfSzrMMDFFC3PS5QR",
  },
  {
    id: "u3Rpm69mqRsWvS6siwuq",
    square: 62,
    createdOn: { seconds: 1606834810, nanoseconds: 667000000 },
    name: "Edgar T",
  },
  {
    square: 33,
    createdOn: { seconds: 1606835833, nanoseconds: 890000000 },
    name: "Jimmy & Lisa",
    id: "uYEnOOEsCgYIGJ3mlbaB",
  },
  {
    createdOn: { seconds: 1606833988, nanoseconds: 808000000 },
    name: "Katie & Rita",
    id: "uv02pLxlyJQTlCY1DRLb",
    square: 52,
  },
  {
    square: 47,
    createdOn: { seconds: 1608562695, nanoseconds: 786000000 },
    id: "voHAlLDZwdeu4gnmZ4wT",
    name: "Alex Z",
  },
  {
    createdOn: { seconds: 1606837058, nanoseconds: 252000000 },
    id: "xW3LL1Itdfpw5InisHZl",
    name: "Zach & Hannah",
    square: 22,
  },
  {
    createdOn: { seconds: 1606838057, nanoseconds: 360000000 },
    square: 42,
    name: "Brian C",
    id: "xblgbPO4Sp5GrnPLlyOT",
  },
  {
    name: "Chad & Hannah",
    square: 18,
    createdOn: { seconds: 1606838231, nanoseconds: 686000000 },
    id: "xfu2Lmm2cQzd9Cj0ROcl",
  },
  {
    createdOn: { seconds: 1606837384, nanoseconds: 5000000 },
    square: 35,
    name: "Dustin & Leah",
    id: "yTDyHDn6UmK4PMk680VA",
  },
  {
    id: "zD4hs5dQdRNPSdrYPaVX",
    createdOn: { seconds: 1606844092, nanoseconds: 582000000 },
    name: "Phil C",
    square: 24,
  },
];
